import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RouterState } from '@angular/router';
import { environment } from '@environment';
import { TranslocoService } from '@ngneat/transloco';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MetaDataService {
  constructor(private router: Router, private titleService: Title, private translocoService: TranslocoService) {}

  private static getTitleChunks(
    state: RouterState,
    parent: ActivatedRoute,
    translocoService: TranslocoService,
  ): string[] {
    let data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      const title = translocoService.translate(parent.snapshot.data.title);
      data = data.concat(title);
    }

    if (state && parent) {
      data = data.concat(...MetaDataService.getTitleChunks(state, parent.firstChild, translocoService));
    }

    return data;
  }

  setTitle(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.titleService.setTitle(this.getTitle() || environment.defaultTitle));
  }

  private getTitle(): string {
    return MetaDataService.getTitleChunks(this.router.routerState, this.router.routerState.root, this.translocoService)
      .reverse()
      .join(' – ');
  }
}
